module.exports = __webpack_public_path__ + "images/what_is_cvc_4648d71.png";